<mat-form-field appearance="outline" class="form-ultra-slim" subscriptSizing="dynamic">
  <mat-label>Icon</mat-label>
  @if (selectedKey()) {
    <mat-icon matPrefix [svgIcon]="selectedKey()" [style.color]="tintColor()"></mat-icon>
  }
  <input
    matInput
    [value]="displayValue()"
    (input)="onSearchInput($any($event.target).value)"
    [matAutocomplete]="auto"
    placeholder="Search icon..." />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    @for (key of filteredKeys(); track key) {
      <mat-option [value]="key">
        <mat-icon [svgIcon]="key" [style.color]="tintColor()" class="icon-preview align-middle me-1"></mat-icon>
        {{ key }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
